<template>
    <div v-loading.fullscreen.lock="loading">
        <route-team-search-bar-component
            add_auth="新增权限分组"
            :AllModel="fAllModel"
            @search="get_route_team_index"
            @addTeam="addTeam"
        ></route-team-search-bar-component>
        <common-table-component
            details_auth="权限分组详情"
            :col_arr="fcol_arr"
            :table_data="ftable_data"
            @details_row="details_route_team"
        ></common-table-component>
        <common-page-component
            :current_page="cond.page"
            :page_size="cond.limit"
            :total="ftotal"
            @search="get_route_team_index"
        ></common-page-component>
        <route-team-edit-component
            edit_auth="修改权限分组"
            del_auth="删除权限分组"
            :id="fid"
            :show_type="edit_type"
            :AllModel="fAllModel"
            :dialogFormVisible="fdialogFormVisible"
            :route_team_details_data="froute_team_details_data"
            @exitRouteTeamDialog="dialogExit"
            @search="get_route_team_index"
            @show_edit="show_edit"
            @details_row="details_route_team"
        ></route-team-edit-component>
    </div>
</template>

<script>
import { route_team_index_request,route_team_details_request } from '@/network/RouteTeam.js'
import { route_model_list_request } from '@/network/list.js'

import RouteTeamSearchBarComponent from '@/components/RouteTeam/RouteTeamSearchBarComponent'
import CommonTableComponent from '@/components/common/CommonTableComponent'
import CommonPageComponent from '@/components/common/CommonPageComponent'
import RouteTeamEditComponent from '@/components/RouteTeam/RouteTeamEditComponent'

export default {
    name: 'RouteTeamView',
    data() {
        return {
            fid: 0,
            edit_type: 0,
            fdialogFormVisible: false,
            loading: true,
            ftotal: 0,
            cond: {
                name: '',
                model_id: '',
                page: 1,
                limit: 10,
            },
            ftable_data: [],
            fcol_arr: [
                {
                    prop: 'iconImg',
                    label: '图标',
                    width: '65px',
                    icon: true,
                },
                {
                    prop: 'name',
                    label: '分组名称',
                    minWidth: '150px'
                },
                {
                    prop: 'model_name',
                    label: '所属分类',
                    minWidth: '150px'
                },
            ],
            froute_team_details_data: {},
            fAllModel: [],
        }
    },
    computed: {},
    methods: {
        addTeam() {
            this.edit_type = 1
            this.fdialogFormVisible = true
        },
        show_edit() {
            this.edit_type = 2
        },
        get_route_team_index(param = {}) {
            this.loading = true
            this.cond.name = param.name ?? this.cond.name
            this.cond.model_id = param.model_id ?? this.cond.model_id
            this.cond.page = param.page ?? this.cond.page
            if (param.limit) {
                this.cond.limit = param.limit
                this.cond.page = 1
            }

            route_team_index_request(this.cond)
                .then((s) => {
                    this.loading = false
                    if (s.status === 0) {
                        this.ftable_data = s.result.data.map((v) => {
                            v.iconImg = v.icon
                            return v
                        })
                        this.ftotal = s.result.total
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.loading = false
                    this.$message.error(err)
                })
        },
        details_route_team(id) {
            this.fid = id
            this.fdialogFormVisible = true
            route_team_details_request(id)
                .then((s) => {
                    if (s.status === 0) {
                        this.froute_team_details_data = s.result
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        get_all_model() {
            route_model_list_request({})
                .then((s) => {
                    if (s.status === 0) {
                        this.fAllModel = s.result
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.loading = false
                    this.$message.error(err)
                })
        },
        dialogExit() {
            this.fdialogFormVisible = false
            this.fid = 0
            this.edit_type = 0
        },
    },
    filters: {},
    props: {},
    created() {
        this.get_route_team_index()
        this.get_all_model()
    },
    destoryed() {},
    mounted() {},
    updated() {},
    components: {
        RouteTeamSearchBarComponent,
        CommonTableComponent,
        CommonPageComponent,
        RouteTeamEditComponent,
    },
    watch: {},
}
</script>

<style lang='less'></style>